import React from 'react'
import AboutHero from '../components/AboutHero'
import IntroSection from '../components/IntroSection '
import TeacherSection from '../components/TeacherSection'
function Aboutus() {
  return (
    <>
    <AboutHero/>
    <IntroSection/>
    <TeacherSection/>
    </>
  )
}

export default Aboutus ;